<template>
  <div>
    <slot name="header"></slot>
    <div class="wrapper">
      <div class="content PSLKanda4Pro">
        <template v-if="!isEditProfile">
          <div>
            <div class="center mb-5">
              <div class="profile-image-wrapper">
                <div
                  class="profile-image"
                  :style="{
                    backgroundImage: `url(${
                      $store.state.member.profile_pic
                        ? $store.state.member.profile_pic
                        : '@/assets/img_register.png'
                    })`,
                  }"
                ></div>
              </div>
            </div>
            <div
              class="text-center primary--text mb-5"
              style="font-size: 28px;"
            >
              {{ user.first_name }} {{ user.last_name }}
            </div>
            <div style="font-size: 14px;">
              <v-row>
                <v-col cols="6" class="d-flex align-center"
                  ><v-icon left class="pb-1">mdi-cake-variant-outline</v-icon>
                  {{ $t("birthday") }} :</v-col
                >
                <v-col cols="6" class="d-flex align-center">{{
                  user.dob ? formatDate(user.dob) : "-"
                }}</v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6" class="d-flex align-center"
                  ><v-icon left class="pb-1">mdi-phone-outline</v-icon
                  >{{ $t("phone_number") }} :</v-col
                >
                <v-col cols="6" class="d-flex align-center">{{
                  user.phone_number
                }}</v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6" class="d-flex align-center"
                  ><v-icon left>mdi-email-outline</v-icon
                  >{{ $t("email") }} :</v-col
                >
                <v-col
                  cols="6"
                  class="d-flex align-center"
                  style="word-break: break-all;"
                  >{{ user.email }}</v-col
                >
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6" class="d-flex align-center"
                  ><v-icon left>mdi-checkbook</v-icon
                  >{{ $t("rop_number") }} :</v-col
                >
                <v-col cols="6" class="d-flex align-center">{{
                  user.rop_number ? user.rop_number : "-"
                }}</v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6" class="d-flex align-center"
                  ><v-icon left>mdi-earth</v-icon
                  >{{ $t("nationality") }} :</v-col
                >
                <v-col cols="6" class="d-flex align-center">{{
                  user.nationality ? user.nationality : "-"
                }}</v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6" class="d-flex align-center"
                  ><v-icon left>mdi-passport</v-icon
                  >{{ $t("passport_no") }} :</v-col
                >
                <v-col cols="6" class="d-flex align-center">{{
                  user.passport_no ? user.passport_no : "-"
                }}</v-col>
              </v-row>
              <v-divider></v-divider>
              <div class="text-center" style="margin-top: 48px">
                <div>
                  <v-btn
                    outlined
                    dark
                    width="200px"
                    rounded
                    color="primary"
                    @click="onEditProfile"
                  >
                    <v-icon class="pr-1">edit</v-icon> {{ $t("edit_profile") }}
                  </v-btn>
                </div>
                <div class="mt-6">
                  <v-btn
                    color="primary"
                    width="200px"
                    text
                    ripple
                    style="text-decoration: underline;"
                    @click="onRedirectPrivacy"
                    >{{ $t("privacy_notice") }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="center mb-5">
            <div class="profile-image-wrapper">
              <div
                class="profile-image"
                :style="{
                  backgroundImage: `url(${
                    $store.state.member.profile_pic
                      ? $store.state.member.profile_pic
                      : '@/assets/img_register.png'
                  })`,
                }"
              ></div>
            </div>
          </div>
          <ProfileForm
            :type="'edit'"
            v-model="user"
            @onEditSuccess="onEditSuccess"
          ></ProfileForm>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileForm from "@/components/ProfileForm.vue";
import moment from "moment";

export default {
  components: {
    ProfileForm,
  },
  data() {
    return {
      isEditProfile: false,
      // user: [],
    };
  },
  mounted() {
    let vm = this;
    vm.scrollTop();
  },
  computed: {
    moment() {
      return moment;
    },
    user() {
      return this.$store.state.member;
    },
  },
  methods: {
    async onEditProfile() {
      let vm = this;
      vm.isEditProfile = true;
    },
    async onEditSuccess() {
      let vm = this;
      vm.isEditProfile = false;
    },
    onRedirectPrivacy() {
      let vm = this;
      vm.query.view = "PrivacyNotice";
    },
    close() {
      let vm = this;
      if (vm.query.apptype == "line") {
        vm.$liff.closeWindow();
      } else {
        vm.$store.dispatch("messengerClose");
      }
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        // behavior: 'smooth'
      });
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.content {
  padding: 120px 24px 24px;
  max-width: 500px;
  margin: 0 auto;
}
.profile-image-wrapper {
  display: inline-block;
}
.profile-image {
  background-size: cover;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  width: 150px;
  height: 150px;
  border: 2px solid #330066;
}
</style>
